export const SET_VIDEO_ID = 'video/SET_VIDEO_ID';
export const SET_VIDEO_URL = 'video/SET_VIDEO_URL';
export const SET_VIDEO_STUDY_TIME = 'video/SET_VIDEO_STUDY_TIME';
export const SET_VIDEO_LOOK_TIME = 'video/SET_VIDEO_LOOK_TIME';
export const SET_VIDEO_lASTCREATE_TIME = 'video/SET_VIDEO_lASTCREATE_TIME';
export const SET_VIDEO_lASTSTUDY_TIME = 'video/SET_VIDEO_lASTSTUDY_TIME';
export const SET_COURSE_INFO = 'video/SET_COURSE_INFO';
export const SET_TEACHER_INFO = 'video/SET_TEACHER_INFO';
export const SET_TEACHER_AREA = 'video/SET_TEACHER_AREA';
export const SET_COMMENT_LIST = 'video/SET_COMMENT_LIST';
export const SET_COMMENT_LOADER = 'video/SET_COMMENT_LOADER';
export const SET_COMMENT_PAGE = 'video/SET_COMMENT_PAGE';
export const CHANGE_TAB = 'video/CHANGE_TAB';
export const HANDLE_COMMENT_TEXTAREA_CHANGE= 'video/HANDLE_COMMENT_TEXTAREA_CHANGE';
export const HANDLE_RATE_CHANGE = 'video/HANDLE_RATE_CHANGE';
export const HANDLE_QUILL_CHANGE = 'video/HANDLE_QUILL_CHANGE';
export const HANDLE_ASK_QUESTION_INPUT_CHANGE = 'video/HANDLE_ASK_QUESTION_INPUT_CHANGE';
export const SET_SOLVE_LIST = 'video/SET_SOLVE_LIST';
export const SET_SOLVE_LOADER = 'video/SET_SOLVE_LOADER';
export const SET_SOLVE_PAGE = 'video/SET_SOLVE_PAGE';
export const SET_NOTE_LIST = 'video/SET_NOTE_LIST';
export const SET_NOTE_LOADER = 'video/SET_NOTE_LOADER';
export const SET_NOTE_PAGE = 'video/SET_NOTE_PAGE';
export const HANDLE_NOTE_TEXTAREA_CHANGE = 'video/HANDLE_NOTE_TEXTAREA_CHANGE';















